{
  "nl": {
    "editor_ziggu": {
      "actions": {
        "apply": "Toepassen",
        "cancel": "Annuleren",
        "link": "Link",
        "showLess": "Toon minder",
        "showMore": "Toon meer"
      },
      "labels": {
        "blue": "Blauw",
        "green": "Groen",
        "link_text": "Link tekst",
        "orange": "Oranje",
        "pink": "Roze",
        "purple": "Paars",
        "red": "Rood",
        "remove_highlight": "Markering verwijderen",
        "yellow": "Geel"
      },
      "placeholders": {
        "content": "Begin met typen..",
        "link": "Typ/plak een link"
      }
    }
  }
}
